export default "__VITE_ASSET__DQHcBPDX__"